export default "/images/vendor/flag-icon-css/flags/4x3/lu.svg?adc8f77e99b53bd83b54e64df9ee9ceb";